import Logo from "@/components/logo"
import { useAuthStore } from "@/store/auth"
import { useFeatureAccessStore } from "@/store/featureAccess"
import { Menu, Row, Button as AntButton, Col } from "antd"
import { DoubleLeftOutlined, DoubleRightOutlined } from "@ant-design/icons"
import React, { FC, useEffect, useMemo, useState } from "react"
import axios from "axios"
import { camerasHeaders, camerasUrl } from "@/pages/Cameras/api"
import { NavLink, useLocation, useNavigate } from "react-router-dom"
import { useTernaryDarkMode } from "usehooks-ts"
import { PlatformFeature } from "@/hooks/useFeatureAccess"
import { useMarketingCapture } from "@/marketingCapture/useMarketingCapture"
import { getStaffToken, isAppProductHost, isStaffAdminHost } from "@/adminHost"
import "./index.less"

// Custom SVG Icons matching the Material-UI icons
const DashboardIcon = () => (
  <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium ant-menu-item-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" width="16" height="16">
    <path d="M19 5v2h-4V5zM9 5v6H5V5zm10 8v6h-4v-6zM9 17v2H5v-2zM21 3h-8v6h8zM11 3H3v10h8zm10 8h-8v10h8zm-10 4H3v6h8z"></path>
  </svg>
);

const IntelligenceStudioIcon = () => (
  <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium ant-menu-item-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" width="16" height="16">
    <path d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7m2.85 11.1-.85.6V16h-4v-2.3l-.85-.6C7.8 12.16 7 10.63 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1"></path>
  </svg>
);

const DataDimensionStudioIcon = () => (
  <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium ant-menu-item-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" width="16" height="16">
    <path d="M12 2 2 7l10 5 10-5zm0 9.55L4.21 7.78 12 4l7.79 3.78zM2 12.5l1.76.88L12 17.55l8.24-4.17L22 12.5v2.24l-10 5.06-10-5.06zm0 4.5 1.76.88L12 22.55l8.24-4.17L22 17v2.24l-10 5.06L2 19.24z"></path>
  </svg>
);

const WorkspaceLensesIcon = () => (
  <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium ant-menu-item-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" width="16" height="16">
    <path d="M4 19h16v2H4zm1-3 4-5 3 3 5-7 2 1.4-7 9.6-3-3-2.5 3.1z"></path>
  </svg>
);

const OperationsIcon = () => (
  <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium ant-menu-item-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" width="16" height="16">
    <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"></path>
  </svg>
);

const AutomationStudioIcon = () => (
  <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium ant-menu-item-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" width="16" height="16">
    <path d="M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z"></path>
  </svg>
);

const ConnectorLibraryIcon = () => (
  <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium ant-menu-item-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" width="16" height="16">
    <path d="M2 20h20v-4H2zm2-3h2v2H4zM2 4v4h20V4zm4 3H4V5h2zm-4 7h20v-4H2zm2-3h2v2H4z"></path>
  </svg>
);

const MarketplaceIcon = () => (
  <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium ant-menu-item-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" width="16" height="16">
    <path d="m9.17 6 2 2H20v10H4V6zM10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8z"></path>
  </svg>
);

const SettingsIcon = () => (
  <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium ant-menu-item-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" width="16" height="16">
    <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"></path>
  </svg>
);

const FAQIcon = () => (
  <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium ant-menu-item-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" width="16" height="16">
    <path d="M15 4v7H5.17l-.59.59-.58.58V4zm1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1m5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1"></path>
  </svg>
);

const HelpCenterIcon = () => (
  <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium ant-menu-item-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" width="16" height="16">
    <path d="M11 18h2v-2h-2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4"></path>
  </svg>
);

const SystemSettingsIcon = () => (
  <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium ant-menu-item-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" width="16" height="16">
    <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"></path>
  </svg>
);

interface AsideMenuProps {
  collapsed: boolean;
  onToggleCollapse: () => void;
}

const AsideMenu: FC<AsideMenuProps> = ({ collapsed, onToggleCollapse }) => {
  const { isDarkMode } = useTernaryDarkMode({ localStorageKey: "theme" });
  const location = useLocation();
  const navigate = useNavigate();
  const hidePreviewBadges = useMarketingCapture().allowed;
  const userRole = useAuthStore((store) => store.user?.role);
  const staffSession = Boolean(getStaffToken());
  const staffHost = isStaffAdminHost();
  const { features: allFeatures, initialized } = useFeatureAccessStore();
  const [hasCameras, setHasCameras] = useState(false);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(camerasUrl('/api/cameras/availability'), { headers: camerasHeaders(), timeout: 8000 })
      .then((response) => {
        if (!cancelled) setHasCameras(!!response.data?.enabled);
      })
      .catch(async (error) => {
        if (error?.response?.status !== 404) {
          if (!cancelled) setHasCameras(false);
          return;
        }
        try {
          const library = await axios.get(camerasUrl('/api/cameras/library'), { headers: camerasHeaders(), timeout: 20000 });
          const sites = library.data?.sites || [];
          if (!cancelled) setHasCameras(sites.some((site: { cameras?: unknown[] }) => (site.cameras || []).length > 0));
        } catch {
          if (!cancelled) setHasCameras(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const canSee = (feature: PlatformFeature) => {
    if (userRole === 'SUPER_ADMIN' || !initialized || allFeatures.length === 0) return true;
    return allFeatures.some((entry) => entry.feature === feature && entry.hasAccess);
  };

  const fleetChildren = canSee(PlatformFeature.FLEET_TRACKING)
    ? [
        { key: "/fleet/vehicles", label: "Vehicles" },
        { key: "/fleet/drivers", label: "Drivers" },
        { key: "/fleet/places", label: "Places" },
        { key: "/fleet/engine", label: "Engine Diagnosis" },
      ]
    : [];
  const operationChildren = [...fleetChildren];
  if (hasCameras) {
    const cameraChild = { key: "/cameras", label: "Cameras" };
    const placesAt = operationChildren.findIndex((child) => child.key === "/fleet/places");
    operationChildren.splice(placesAt >= 0 ? placesAt + 1 : operationChildren.length, 0, cameraChild);
  }
  const operationsKey = fleetChildren.length ? "/fleet" : "/cameras";
  const visibleOperationChildren = operationChildren.filter((child) => child.key !== operationsKey || operationChildren.length > 1);

  // Define all menu items with their associated features
  const allMenuItems = [
    { key: "/dashboard", icon: <DashboardIcon />, label: "Dashboard", feature: PlatformFeature.DASHBOARD },
    { key: "/connector-library", icon: <ConnectorLibraryIcon />, label: "Connector Library", feature: PlatformFeature.CONNECTOR_LIBRARY },
    { key: "/intelligence-insights", icon: <IntelligenceStudioIcon />, label: "Intelligence Insights", feature: PlatformFeature.INTELLIGENCE_STUDIO },
    { key: "/data-dimension-studio", icon: <DataDimensionStudioIcon />, label: "Data Dimension Studio", feature: PlatformFeature.DATA_DIMENSION_STUDIO },
    { key: "/workspace-lenses", icon: <WorkspaceLensesIcon />, label: "Lenses", feature: PlatformFeature.WORKSPACE_LENSES },
    ...(fleetChildren.length || hasCameras
      ? [{
          key: operationsKey,
          icon: <OperationsIcon />,
          label: "Operations",
          feature: fleetChildren.length ? PlatformFeature.FLEET_TRACKING : PlatformFeature.DATA_DIMENSION_STUDIO,
          children: visibleOperationChildren,
        }]
      : []),
    { key: "/automation-studio", icon: <AutomationStudioIcon />, label: "Automation Studio", feature: PlatformFeature.AUTOMATION_STUDIO },
  ];

  const allSupportMenuItems = [
    { key: "/faq", icon: <FAQIcon />, label: "FAQ", feature: PlatformFeature.SUPPORT_FAQ },
    { key: "/help-center", icon: <HelpCenterIcon />, label: "Help Center", feature: PlatformFeature.HELP_CENTER },
  ];

  const allAdminMenuItems = useMemo(() => {
    const consoleItem = { key: "/admin", icon: <SystemSettingsIcon />, label: "Admin Console", feature: PlatformFeature.ADMIN_CONSOLE };
    if (!staffHost) return [consoleItem];
    return [
      consoleItem,
      { key: "/admin/pipeline/companies", icon: <DashboardIcon />, label: "Pipeline", feature: PlatformFeature.ADMIN_CONSOLE },
      { key: "/admin?tab=automations", icon: <AutomationStudioIcon />, label: "Automations", feature: PlatformFeature.ADMIN_CONSOLE },
      { key: "/admin/customers", icon: <MarketplaceIcon />, label: "Customers", feature: PlatformFeature.ADMIN_CONSOLE },
    ];
  }, [staffHost]);

  // Filter menu items based on feature access
  const menuItems = useMemo(() => {
    if (staffHost) return [];
    if (userRole === 'SUPER_ADMIN') return allMenuItems;
    
    // If not initialized yet, show all basic menu items as fallback to prevent blank menu
    // This ensures users can navigate even if feature access API fails
    if (!initialized) {
      console.warn('[AsideMenu] Feature access not initialized, showing default menu items');
      return allMenuItems; // Show all items by default until we know for sure
    }
    
    // If initialized but no features (API failed), show basic access
    if (allFeatures.length === 0) {
      console.warn('[AsideMenu] No features loaded, showing default menu items');
      return allMenuItems; // Show all items if feature access failed to load
    }
    
    return allMenuItems.filter(item => {
      const featureAccess = allFeatures.find(f => f.feature === item.feature);
      return featureAccess?.hasAccess;
    });
  }, [allFeatures, initialized, userRole, staffHost, hasCameras]);

  useEffect(() => {
    if (!menuItems.some((item) => item.key === '/fleet')) return;
    void import('@/pages/Fleet/FleetMapPage');
    void import('@/pages/Fleet/EngineDiagnosisPage');
  }, [menuItems]);

  const supportMenuItems = useMemo(() => {
    if (staffHost) return [];
    if (userRole === 'SUPER_ADMIN') return allSupportMenuItems;
    if (!initialized || allFeatures.length === 0) {
      return allSupportMenuItems; // Show support items by default
    }
    
    return allSupportMenuItems.filter(item => {
      const featureAccess = allFeatures.find(f => f.feature === item.feature);
      return featureAccess?.hasAccess;
    });
  }, [allFeatures, initialized, userRole, staffHost]);

  const adminMenuItems = useMemo(() => {
    if (isAppProductHost()) return [];
    if (staffSession || userRole === 'SUPER_ADMIN') return allAdminMenuItems;
    return [];
  }, [allAdminMenuItems, userRole, staffSession]);

  const utilityItems = useMemo(() => {
    const settingsItem = { key: "/settings", icon: <SettingsIcon />, label: "Settings", feature: PlatformFeature.ACCOUNT };
    const settingsVisible = (() => {
      if (staffHost) return false;
      if (userRole === 'SUPER_ADMIN' || !initialized || allFeatures.length === 0) return true;
      const accountAccess = allFeatures.find(f => f.feature === PlatformFeature.ACCOUNT);
      const systemAccess = allFeatures.find(f => f.feature === PlatformFeature.SYSTEM_SETTINGS);
      return Boolean(accountAccess?.hasAccess || systemAccess?.hasAccess);
    })();
    return [
      ...supportMenuItems,
      ...(settingsVisible ? [settingsItem] : []),
    ];
  }, [allFeatures, initialized, userRole, staffHost, supportMenuItems]);

  const selectedKeys = useMemo(() => {
    if (location.pathname.startsWith('/cameras')) {
      return ['/fleet', '/cameras'];
    }
    if (location.pathname.startsWith('/fleet')) {
      return ['/fleet'];
    }
    if (location.pathname.startsWith('/admin/pipeline')) {
      return ['/admin/pipeline/companies'];
    }
    if (location.pathname.startsWith('/admin/customers') || location.pathname.startsWith('/admin/billing')) {
      return ['/admin/customers'];
    }
    if (location.pathname.startsWith('/admin')) {
      return ['/admin'];
    }
    if (
      location.pathname.startsWith('/settings') ||
      location.pathname.startsWith('/account') ||
      location.pathname.startsWith('/system-settings')
    ) {
      return ['/settings'];
    }
    return [location.pathname];
  }, [location.pathname]);

  const menuHeader = null;
  const adminHeader = !collapsed ? <span className="menu-section-title admin-title">ADMIN</span> : null;
  const operationsOpen = !collapsed && (location.pathname.startsWith('/fleet') || location.pathname.startsWith('/cameras'));

  return (
    <div className={`aside-menu-container ${collapsed ? "collapsed" : ""}`}>
      {!collapsed && (
        <Row className="aside-menu-logo">
          <Col span={24}>
            <Logo />
          </Col>
        </Row>
      )}
      
      <div className="aside-menu-header-with-trigger">
        {!collapsed && <span className="menu-section-title menu-main-title">MENU</span>}
        <AntButton 
          className={`aside-menu-collapse-trigger ${isDarkMode ? "dark" : "light"} ${collapsed ? "collapsed" : ""}`}
          onClick={onToggleCollapse}
          icon={collapsed ? <DoubleRightOutlined /> : <DoubleLeftOutlined />}
        />
      </div>
      
      <Menu
        mode="inline"
        className="aside-menu aside-menu-items"
        selectedKeys={selectedKeys}
        inlineCollapsed={collapsed}
      >
        {menuItems.length > 0 && (
          <Menu.ItemGroup key="g1" title={menuHeader}>
            {menuItems.flatMap(item => {
              const children = (item as { children?: { key: string; label: string }[] }).children;
              const nodes = [
                <Menu.Item
                  key={item.key}
                  icon={item.icon}
                  onClick={collapsed ? () => navigate(item.key) : undefined}
                >
                  <NavLink to={item.key} className="aside-menu-link">
                    <span className="aside-menu-label">{item.label}</span>
                    {(item as { inPreview?: boolean }).inPreview && !hidePreviewBadges && (
                      <span className="menu-item-in-preview">Preview</span>
                    )}
                  </NavLink>
                </Menu.Item>,
              ];
              if (operationsOpen && children) {
                children.forEach((child) => {
                  nodes.push(
                    <Menu.Item
                      key={child.key}
                      className={`aside-menu-child${location.pathname.startsWith(child.key) ? ' is-current' : ''}`}
                    >
                      <NavLink to={child.key} className="aside-menu-link">
                        <span className="aside-menu-label">{child.label}</span>
                      </NavLink>
                    </Menu.Item>,
                  );
                });
              }
              return nodes;
            })}
          </Menu.ItemGroup>
        )}
        {adminMenuItems.length > 0 && (
          <Menu.ItemGroup key="g3" title={adminHeader}>
            {adminMenuItems.map(item => (
              <Menu.Item 
                key={item.key} 
                icon={item.icon}
                onClick={collapsed ? () => navigate(item.key) : undefined}
              >
                <NavLink to={item.key}>{item.label}</NavLink>
              </Menu.Item>
            ))}
          </Menu.ItemGroup>
        )}
      </Menu>
      {utilityItems.length > 0 && (
        <div className="aside-menu-footer">
          {utilityItems.map((item) => {
            const active =
              item.key === '/settings'
                ? location.pathname.startsWith('/settings') ||
                  location.pathname.startsWith('/account') ||
                  location.pathname.startsWith('/system-settings')
                : location.pathname.startsWith(item.key);
            return (
              <NavLink
                key={item.key}
                to={item.key}
                className={`aside-menu-footer-link${active ? ' is-active' : ''}`}
                title={item.label}
              >
                {item.icon}
                {!collapsed && <span>{item.label}</span>}
              </NavLink>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AsideMenu;
